<template>
     <span class="hex" :style="{'width':width,'height':height}">
         <span class="hexIn" :style="{'background':background}">
             <img v-if="imgUrl" :src="imgUrl" alt="" :style="{'width':imgWidth,'margin-top':imgTop}">
             <img class="playerHead" v-else src="../assets/img/updateImg/playerHead.png" alt="" :style="{'width':imgWidth}">
         </span>
     </span>
</template>

<script>
    export default {
        name: "photoCard",
        props: {
            imgUrl: String,
            width: String,
            height: String,
            background: String,
            imgWidth: String,
            imgTop:String
        }
    }
</script>

<style scoped lang="less">
    .playerHead{
        margin-top: 15% !important;
    }
    .hex {
        overflow: hidden;
        display: inline-block;
        width: 7vw;
        height: 8vw;
        transform: rotate(-60deg) skewY(30deg);
        color: #fff;
    }

    .hexIn {
        display: inline-block;
        width: 100%;
        height: 100%;
        text-align: center;
        overflow: hidden;
        transform: skewY(-30deg) rotate(60deg);
        background-color: rgba(12, 12, 13, 0.45);

        img {
            /*margin-top: 10%;*/
            width: 100%;
        }
    }
</style>
